import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import PlaceholderPage from "components/PlaceholderPage";
import ContactContent from "page_components/client/contact/Content";
import DashboardContentLayout from "components/layouts/DashboardContentLayout";

const Contact = () => {
  const { t } = useTranslation();

  const { websites } = useApp();
  const [form_sent, setFormSent] = useState(false);

  const actions = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  return (
    <DashboardContentLayout
      header={{
        label: t(!!form_sent ? "Message sent confirmation" : "Contact"),
        description: t(
          !!form_sent
            ? "Everything went smoothly."
            : "Need help? Our customer service team is at your disposal.",
        ),
      }}
      actions={!!form_sent ? null : actions}
    >
      {!!form_sent ? (
        <PlaceholderPage
          title={t("The message has been sent.")}
          text={t(
            "Thank you for reaching out. We will get back to you as soon as possible.",
          )}
          button={{
            label: t("Dashboard"),
            href: "/",
          }}
        />
      ) : (
        <ContactContent setFormSent={setFormSent} />
      )}
    </DashboardContentLayout>
  );
};

export default Contact;
